import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngMessages from 'angular-messages';
import changePasswordComponent from './change-password.component';

let changePasswordModule = angular.module('change-password', [
    uiRouter,
    ngMessages
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
    $stateProvider
    .state('change-password', {
        url: '/change-password',
        component: 'changePassword',
        parent: 'main',
        data: {
            permissions: {
                only: ['AUTHORIZED'],
                redirectTo: 'login'
            }
        }
    });
})
.component('changePassword', changePasswordComponent)
.name;

export default changePasswordModule;
